import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
    adminMobile: string;
    adminName: string;
    adminRole: string;
    adminFarmId: string;
    locationName: string;
    lastLogin: string;
    presentLogin: string;
    isAuthenticated: boolean;
    adminUserId: number | null;
    screenAccess: Record<string, string>; // key -> "full" | "view" | "none"
}

const initialState: AuthState = {
    adminMobile: '',
    adminName: '',
    adminRole: '',
    adminFarmId: '',
    locationName: '',
    lastLogin: '',
    presentLogin: '',
    isAuthenticated: false,
    adminUserId: null,
    screenAccess: {},
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setSession: (state, action: PayloadAction<Omit<AuthState, 'isAuthenticated'>>) => {
            return { ...action.payload, isAuthenticated: true };
        },
        clearSession: () => initialState,
        setScreenAccess: (state, action: PayloadAction<Record<string, string>>) => {
            state.screenAccess = action.payload;
        },
        setAdminUserId: (state, action: PayloadAction<number>) => {
            state.adminUserId = action.payload;
        },
    },
});

export const { setSession, clearSession, setScreenAccess, setAdminUserId } = authSlice.actions;
export const authReducer = authSlice.reducer;
export default authSlice.reducer;
